import { STORE_BULK_PRICING_TYPE } from '../constants/storeCheckout.constants';
import type { StoreReviewPricingModel } from './storeReviewPricing.utils';
import type { BulkPricingType, IUpdateStoreRequest } from '@/common/interfaces/store.interface';

export const mapStoreReviewPricingModelToBulkPricingType = (
  pricingModel: StoreReviewPricingModel
): BulkPricingType =>
  pricingModel === 'drops'
    ? STORE_BULK_PRICING_TYPE.PRICE_DROPS
    : STORE_BULK_PRICING_TYPE.PRICE_STAYS_SAME;

const LEGACY_PRICE_STAYS_SAME = 'price_stays_the_same';

export const normalizeBulkPricingType = (value: unknown): BulkPricingType | undefined => {
  if (value === STORE_BULK_PRICING_TYPE.PRICE_DROPS) {
    return STORE_BULK_PRICING_TYPE.PRICE_DROPS;
  }

  if (value === STORE_BULK_PRICING_TYPE.PRICE_STAYS_SAME || value === LEGACY_PRICE_STAYS_SAME) {
    return STORE_BULK_PRICING_TYPE.PRICE_STAYS_SAME;
  }

  return undefined;
};

export const mapBulkPricingTypeToStoreReviewPricingModel = (
  pricingType: BulkPricingType
): StoreReviewPricingModel =>
  pricingType === STORE_BULK_PRICING_TYPE.PRICE_DROPS ? 'drops' : 'same';

export const isBulkPricingType = (value: unknown): value is BulkPricingType =>
  normalizeBulkPricingType(value) != null;

export const buildStoreBulkPricingTypeUpdatePayload = (
  orderId: number,
  orderItemIds: number[],
  pricingModel: StoreReviewPricingModel
): IUpdateStoreRequest => ({
  order_id: orderId,
  bulk_pricing_type_update: {
    order_item_ids: orderItemIds,
    pricing_type: mapStoreReviewPricingModelToBulkPricingType(pricingModel),
  },
});
